/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CustomSortingB.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author : Bharathan - bharathan@au79consulting.com
 * @Date : 01-10-2024
 * @description : Reusable sorting component
 */

import React, { useEffect, useState } from "react";
import {
  Box,
  Menu,
  Typography,
  Divider,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { CustomButton } from "../index";

function CustomSortingB({
  anchorEl,
  open,
  handleClose,
  sortOptionsList,
  selectedSortColumn,
  selectedSortOrder,
  handleSortClick,
  onReset,
  onApplyNow,
}) {
  const [selectToSort, setSelectToSort] = useState(selectedSortColumn);
  const [checkedAscending, setCheckedAscending] = useState(
    selectedSortOrder === true
  );
  const [checkedDescending, setCheckedDescending] = useState(
    selectedSortOrder === false
  );

  // Handle functions
  const handleAscendingChange = (event) => {
    setCheckedAscending(event?.target?.checked);
    setCheckedDescending(!event?.target?.checked);
  };

  const handleDescendingChange = (event) => {
    setCheckedDescending(event?.target?.checked);
    setCheckedAscending(!event?.target?.checked);
  };

  // UseEffects
  useEffect(() => {
    setSelectToSort(selectedSortColumn);

    setCheckedAscending(selectedSortOrder === true);
    setCheckedDescending(selectedSortOrder === false);
  }, [selectedSortColumn, selectedSortOrder]);

  return (
    <Box sx={styles.mainContainer}>
      <CustomButton
        size="small"
        variant="contained"
        btnName="Sort By"
        handleOnClick={handleSortClick}
        btnStyle={styles.customButton}
        startIcon={<SwapVertIcon />}
      />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 12,
          sx: {
            mt: 0.4,
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Typography sx={{ ...styles.heading, ml: "10px" }}>Sort By</Typography>
        <Divider />
        {/* Sort fields */}
        <Box sx={styles.container}>
          <Box>
            <Box sx={{ mt: "10px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedAscending}
                    onChange={handleAscendingChange}
                    name="Ascending"
                    color="primary"
                  />
                }
                label="Old to New"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedDescending}
                    onChange={handleDescendingChange}
                    name="Descending"
                    color="primary"
                  />
                }
                label="New to Old"
              />
            </Box>
          </Box>

          {/* reset & apply now buttons */}
          <Box sx={styles.btBtnsContainer}>
            <CustomButton
              size="small"
              variant="contained"
              btnName="Reset All"
              handleOnClick={onReset}
            />
            <CustomButton
              size="small"
              variant="contained"
              btnName="Apply Now"
              handleOnClick={() =>
                onApplyNow(selectToSort, checkedAscending ? true : false)
              }
            />
          </Box>
        </Box>
      </Menu>
    </Box>
  );
}

export default CustomSortingB;

// Styling
const styles = {
  mainContainer: {
    // mr: "10px ",
  },
  container: {
    px: 1.4,
    py: 0.4,
  },
  customButton: {
    ml: 2,
  },
  btBtnsContainer: {
    display: "flex",
    justifyContent: "space-between",
    mt: 1,
  },
  selectTextField: {
    width: "250px",
    mt: 1,
  },
  heading: {
    fontWeight: "bold",
  },
};
